import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Divider,
  Select,
  Tooltip,
  Form as FormInitial,
  Tag,
} from "antd";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  NotificacionPolizas,
  ButtonItem,
  ErrorItem,
  round10Decimals,
  SwitchItem,
  TextAreaItem
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ArrowUpOutlined, CalculatorOutlined, FireOutlined, WarningOutlined } from "@ant-design/icons";


const { Option } = Select;

moment.locale("es");

class RequerirInsumosVenta extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    datosVenta: undefined,
    todasInsumos: null,
    objetoInsumos: null,
    todasProyectos: null,
    objetoProyectos: null,
    id: this.props.location.state.ventaId,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "ventas/datosVentaPRecibirP",
        {
          empresaId: this.props.empresaId,
          ventaId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then(async (res) => {
        if (res.data.status === 404) {
          message.error(
            "Error no se encontro informacion de la venta"
          );
        } else {
          const ventaInsumos = res.data.venta.insumos || [];

          // Consulta de inventarios en bulk (respeta el proyecto de cada linea y las equivalencias/compuestos)
          const insumosBulk = ventaInsumos.map((row, index) => {
            const insumoOriginal = res.data.insumos.find(i => i._id.toString() === row.insumoId.toString());
            return {
              index,
              insumoId: row.insumoId,
              proyectoId: row.proyectoId,
              inventariable: insumoOriginal?.inventariable,
              noPrincipal: insumoOriginal?.noPrincipal,
              insumoCompuesto: insumoOriginal?.insumoCompuesto,
              componentesKit: row.componentesKit,
            };
          });

          let inventarioPorLinea = ventaInsumos.map(() => 0);
          try {
            const resInventarios = await axios.post(
              "inventarios/inventarioInsumoProyectoBulk",
              { empresaId: this.props.empresaId, insumos: insumosBulk },
              { headers: this.props.headersToken }
            );
            if (resInventarios.data?.results) {
              resInventarios.data.results.forEach(r => {
                inventarioPorLinea[r.index] = r.cantidad || 0;
              });
            }
          } catch (e) {
            console.error("Error al consultar inventario bulk", e);
          }

          const datosVenta = {
            ...res.data.venta,
            insumos: ventaInsumos.map((value, index) => ({
              ...value,
              inventario: inventarioPorLinea[index],
            })),
          };

          this.setState({
            datosVenta,
            todasInsumos: res.data.insumos,
            objetoInsumos: res.data.insumos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
          });
          // Si se indica que se quieren prellenar los faltantes, se calcula el faltante de inventario y se prellena el campo de requerir con ese valor.
          const prefillFaltante = !!this.props.location.state?.prefillFaltanteInventario;

          // Para quitar el insumo de envio
          const insumoEnvioIdStr = res.data.insumoEnvioId
            ? res.data.insumoEnvioId.toString()
            : null;

          const insumosVenta = datosVenta.insumos.filter(
            (item) =>
              !insumoEnvioIdStr ||
              item.insumoId?.toString() !== insumoEnvioIdStr
          );

          this.formRef.current.setFieldsValue({
            insumos: insumosVenta.map(value => ({
              ...value,
              precioUnitarioAjustado: (value.precioUnitario * (1 - (value.descuento / 100))),
              requerir: prefillFaltante
                ? (value.cantidadFaltanteInventario || 0)
                : undefined,
            }))
          });
        }
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    let requerirTodos = 0;
    values.insumos = values.insumos.map(value => {
      let requerir = value.requerir ? value.requerir : 0
      requerirTodos += requerir
      return { ...value, requerir }
    })
    if (requerirTodos === 0) return message.info('Se neceitan cantidades para poder hacer esta operación')
    this.setState({ loading: true });
    axios
      .post(
        "ventas/requerirInsumos",
        {
          ...values,
          empresaId: this.props.empresaId,
          ventaId: this.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se Ha generado la requisicion " + res.data.requisicionNumero
          );
          NotificacionPolizas(res.data.polizasId)
          this.formRef.current.resetFields();
          this.atras(res.data.requisicionNumero);
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "No se pueden requerir los insumos");
        } else {
          message.error("Hubo un error y no se requirieron los insumos");
        }
      });
  }
  atras() {
    this.props.history.goBack();
  }

  calcularRequerirFaltante(fieldKey) {
    //Calcular el faltante por entregar y lo que hay en inventario.
    //Requerir el minimo entre ambos.
    //Si no hay inventario, requerir el faltante.
    const form = this.formRef.current;
    const insumo = this.state.datosVenta?.insumos[fieldKey];
    if (!insumo) return;

    //  Calcular cuánto se debe REQUERIR después de usar el inventario
    const cantidadARequerir = this.cantidadRequerirFaltante(insumo);

    const insumosActuales = form.getFieldValue('insumos') || [];
    const nuevosInsumos = [...insumosActuales];

    nuevosInsumos[fieldKey] = {
      ...nuevosInsumos[fieldKey],
      requerir: cantidadARequerir,
    };

    form.setFieldsValue({ insumos: nuevosInsumos });
    //form.validateFields([['insumos', fieldKey, 'requerir']]).catch(() => { });

  }
  calcularRequerirTotal(fieldKey) {
    //Requerir el total de la venta sin importar si hay inventario o no. 
    const form = this.formRef.current;
    const datosVenta = this.state.datosVenta;
    if (!datosVenta?.insumos[fieldKey]) return;
    const insumo = datosVenta.insumos[fieldKey];
    if (!insumo) return;
    //La cantidad a requerir es la cantidad vendida.
    const cantidadARequerir = this.cantidadRequerirTotal(insumo);

    const insumosActuales = form.getFieldValue('insumos') || [];
    const nuevosInsumos = [...insumosActuales];
    //Directamente pone la cantidad a requerir como la cantidad vendida.
    nuevosInsumos[fieldKey] = {
      ...nuevosInsumos[fieldKey],
      requerir: cantidadARequerir,
    };

    form.setFieldsValue({ insumos: nuevosInsumos });

  }

  calcularTodosLosInsumos = (tipoCalculo) => {
    const form = this.formRef.current;
    const insumosActuales = form.getFieldValue('insumos') || [];
    //Veficicar que haya insumos actuales
    if (insumosActuales.length === 0) return;
    const datosVentaInsumos = this.state.datosVenta?.insumos || [];
    if (datosVentaInsumos.length === 0) return;
    // Se indexa por insumoId (no por posicion) porque la lista de la forma excluye el insumo de envio.
    const mapaInsumosInvetario = new Map(datosVentaInsumos.map(i => [i.insumoId, i]));
    const nuevosInsumos = insumosActuales.map(insumo => {
      const insumoDatos = mapaInsumosInvetario.get(insumo.insumoId);
      if (!insumoDatos) return insumo;
      let cantidadARequerir;
      if (tipoCalculo === 'faltante') {
        cantidadARequerir = this.cantidadRequerirFaltante(insumoDatos);
      }
      else if (tipoCalculo === 'total') {
        cantidadARequerir = this.cantidadRequerirTotal(insumoDatos);
      }
      return {
        ...insumo,
        requerir: cantidadARequerir,
      };
    });
    form.setFieldsValue({ insumos: nuevosInsumos });

  }

  //funciones para calcular la cantidad a requerir
  //Si se modfician modifica el calculo en los botones individuales y en el de todos los insumos.
  cantidadRequerirFaltante = (insumo) => {
    const cantidadVendida = insumo.cantidad || 0;
    const apartado = insumo.apartado || 0;
    const entregado = insumo.entregado || 0;
    const inventarioDisponible = insumo.inventario || 0;

    const faltantePorEntregar = Math.max(0, cantidadVendida - apartado - entregado);
    return Math.max(0, faltantePorEntregar - inventarioDisponible);
  }
  cantidadRequerirTotal = (insumo) => {
    return insumo.cantidad || 0;
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Requerir Insumos sobre Venta"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <h1>
              Fecha:{" "}
              {moment(this.state.datosVenta?.createdAt).format("LL")}
            </h1>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="requerirInsumosFactura"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Requerir
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row >
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <h1 style={{ margin: 0 }}>
                    Proyecto: {this.state.datosVenta?.proyecto.nombre}
                  </h1>
                  <p>
                    Descripcion:{" "}
                    {this.state.datosVenta?.proyecto.descripcion}
                  </p>
                </Col>
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <h1 style={{ margin: 0 }}>Dirección</h1>
                  {this.state.datosVenta?.proyecto.calle ? (
                    <>
                      <p style={{ margin: 0 }}>
                        Calle: {this.state.datosVenta?.proyecto.calle}
                      </p>
                      <p style={{ margin: 0 }}>
                        Numero:{" "}
                        {this.state.datosVenta?.proyecto.numeroCalle}
                      </p>
                    </>
                  ) : (
                    <>
                      <p style={{ margin: 0 }}>
                        Marca: {this.state.datosVenta?.proyecto.marca}
                      </p>
                      <p style={{ margin: 0 }}>
                        Modelo: {this.state.datosVenta?.proyecto.modelo}
                      </p>
                      <p style={{ margin: 0 }}>
                        Placas: {this.state.datosVenta?.proyecto.placas}
                      </p>
                    </>
                  )}
                </Col>
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <h1 style={{ margin: 0 }}>
                    Cliente:{" "}
                    {this.state.datosVenta?.cliente.nombre
                      ? this.state.datosVenta?.cliente.nombre +
                      " " +
                      this.state.datosVenta?.cliente
                        .apellidoPaterno +
                      " " +
                      this.state.datosVenta?.cliente.apellidoMaterno
                      : this.state.datosVenta?.cliente.razonSocial}
                  </h1>
                  <p style={{ margin: 0 }}>
                    Rfc: {this.state.datosVenta?.cliente.rfc}
                  </p>
                  <p style={{ margin: 0 }}>
                    Correo: {this.state.datosVenta?.cliente.correo}
                  </p>
                  <p style={{ margin: 0 }}>
                    Telefono:{" "}
                    {this.state.datosVenta?.cliente.telefono}
                  </p>
                  <p style={{ margin: 0 }}>
                    Celular: {this.state.datosVenta?.cliente.celular}
                  </p>
                </Col>
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <p style={{ margin: 0 }}>
                    Contacto:{" "}
                    {this.state.datosVenta?.cliente.nombreContacto}
                  </p>
                  <p style={{ margin: 0 }}>
                    Tel. Contacto:{" "}
                    {this.state.datosVenta?.cliente.telefonoContacto}
                  </p>
                  <p style={{ margin: 0 }}>
                    Correo Contacto:{" "}
                    {this.state.datosVenta?.cliente.correoContacto}
                  </p>
                  <p style={{ margin: 0 }}>
                    Dias de crédito:{" "}
                    {this.state.datosVenta?.cliente.diasCredito}
                  </p>
                </Col>
              </Row>
              <Divider style={{ marginBottom: 10, marginTop: 5 }} />
              <Row >
                <Col span={12} >
                  <FormItem
                    label="Fecha de Entrega"
                    name="fechaEntrega"
                    required
                    margin
                    initialValue={moment()}
                  >
                    <DatePickerItem
                      placeholder="Fecha de Entrega"
                      allowClear={false}
                    />
                  </FormItem>
                  <FormItem
                    label="Observaciones"
                    name="observaciones"
                    margin
                    pattern
                  >
                    <TextAreaItem placeholder="Observaciones" />
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem
                    label="Separar Ins:"
                    name="separarInsumos"
                    margin
                    initialValue={true}
                    valuePropName="checked"
                    tooltip="¿Esto indicara al momento de recibir la orden de compra, que se separen los insumos?"
                  >
                    <SwitchItem />
                  </FormItem>
                  <FormItem
                    label="Importancia"
                    name="importancia"
                    tooltip="Nivel de importancia: 1 = Baja, 2 = Media, 3 = Alta"
                    margin
                    initialValue={2}
                  >
                    <SelectItem placeholder="Seleccione nivel de importancia" style={{ width: "100%" }}>
                      <Option value={1}>
                        <Tag color="green" style={{ marginRight: 8 }}>
                          <ArrowUpOutlined /> Baja
                        </Tag>
                      </Option>
                      <Option value={2}>
                        <Tag color="orange" style={{ marginRight: 8 }}>
                          <WarningOutlined /> Media
                        </Tag>
                      </Option>
                      <Option value={3}>
                        <Tag color="red" style={{ marginRight: 8 }}>
                          <FireOutlined /> Alta
                        </Tag>
                      </Option>
                    </SelectItem>
                  </FormItem>
                </Col>
              </Row>
              <FormInitial.List name="insumos">
                {(fields) => (
                  <>
                    <div style={{ overflowX: 'auto' }}>
                      <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                        {fields.length > 0 ? (
                          <thead>
                            <tr>
                              <th className="th-border" style={{ width: "20%" }}>
                                Insumo
                              </th>
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Precio Unitario
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Inventario
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Apartado
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Entregado
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Cantidad Pedida
                                </th>}
                              <th className="th-border" style={{ width: "10%" }}>
                                Cantidad a requerir
                                <Row gutter={0} justify="center">
                                  <Col span={8}>
                                    <Tooltip title='Requerir el faltante de todos los insumos'>
                                      <CalculatorOutlined onClick={() => this.calcularTodosLosInsumos('faltante')} style={{ marginLeft: '5px', color: 'green' }} />
                                    </Tooltip>
                                  </Col>
                                  <Col span={8}>
                                    <Tooltip title='Requerir el total de todos los insumos'>
                                      <CalculatorOutlined onClick={() => this.calcularTodosLosInsumos('total')} style={{ marginLeft: '5px', color: '#00b5e2' }} />
                                    </Tooltip>
                                  </Col>

                                </Row>

                              </th>
                            </tr>
                          </thead>
                        ) : null}
                        {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => (
                          <tbody key={fieldKey}>
                            <tr>
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "insumoId"]}
                                  fieldKey={[fieldKey, "insumoId"]}
                                  required
                                  noStyle
                                >
                                  <SelectItem
                                    sinBorde
                                    style={{ width: "100%" }}
                                    placeholder="Insumo"
                                    disabled
                                  >
                                    {this.state.objetoInsumos}
                                  </SelectItem>
                                </FormItem>
                              </td>
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "precioUnitarioAjustado"]}
                                  fieldKey={[fieldKey, "precioUnitarioAjustado"]}
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Precio Unitario"
                                    disabled
                                    dineroDisabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "inventario"]}
                                  fieldKey={[fieldKey, "inventario"]}
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Inventario"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "apartado"]}
                                  fieldKey={[fieldKey, "apartado"]}
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Apartado"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "entregado"]}
                                  fieldKey={[fieldKey, "entregado"]}
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Entregado"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "cantidad"]}
                                  fieldKey={[fieldKey, "cantidad"]}
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Cantidad Vendida"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              <td className="td-border">
                                <Row>
                                  <Col span={14}>
                                    <FormItem shouldUpdate noStyle>
                                      {() => {
                                        let cantidad =
                                          round10Decimals(this.state.datosVenta?.insumos[
                                            fieldKey
                                          ]?.cantidad - (this.state.datosVenta?.insumos[fieldKey]?.apartado || 0));
                                        return (
                                          <FormItem
                                            {...restField}
                                            name={[name, "requerir"]}
                                            fieldKey={[fieldKey, "requerir"]}
                                            numberCero
                                            noStyle
                                            max={cantidad}
                                            type="number"
                                          >

                                            <InputNumberItem
                                              sinBorde
                                              placeholder={"Max: " + cantidad}
                                            />

                                          </FormItem>

                                        );
                                      }}
                                    </FormItem>

                                  </Col>
                                  <Col span={10}>
                                    <Row>
                                      <Col span={8}>
                                        <Tooltip title='Requerir el faltante'>
                                          <CalculatorOutlined onClick={() => this.calcularRequerirFaltante(fieldKey)} style={{ marginLeft: '5px', color: 'green' }} />
                                        </Tooltip>
                                      </Col>
                                      <Col span={8}>
                                        <Tooltip title='Requerir el total'>
                                          <CalculatorOutlined onClick={() => this.calcularRequerirTotal(fieldKey)} style={{ marginLeft: '5px', color: '#00b5e2' }} />
                                        </Tooltip>
                                      </Col>

                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      </table>
                    </div>
                  </>
                )}
              </FormInitial.List>
            </Form>
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(RequerirInsumosVenta);
